import { Icon } from "@indigo-components";
import { useAtom } from "jotai";
import { useMemo } from "react";
import { browserWarningDismissedAtom } from "~/atoms/browserWarning";
import { detectUnsupportedBrowser, UnsupportedBrowser } from "~/utils/browser";

const BROWSER_NAMES: Record<UnsupportedBrowser, string> = {
  safari: "Safari",
  firefox: "Firefox",
  "ios-chrome": "Chrome on iOS",
};

const BrowserWarningBanner = () => {
  const [dismissed, setDismissed] = useAtom(browserWarningDismissedAtom);
  const browser = useMemo(() => detectUnsupportedBrowser(), []);

  if (dismissed || !browser) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-3 bg-amber-500 px-4 py-2 text-indigo-text-on-accent shadow-sm"
    >
      <Icon name="functional-warning-reversed" size="s" />
      <span className="flex-1 text-xs font-medium">
        For the best experience, please use Google Chrome. Some features
        (including embedded Google Docs) may not work correctly in{" "}
        <strong>{BROWSER_NAMES[browser]}</strong>.
      </span>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss browser warning"
        className="rounded p-1 text-white/90 hover:bg-white/10 hover:text-indigo-text-on-accent"
      >
        <Icon name="functional-close" size="s" />
      </button>
    </div>
  );
};

export default BrowserWarningBanner;
